
import { useEffect, useState } from 'react';
import { useAuthState } from '@/hooks/useAuthState';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { ArrowRight, User } from 'lucide-react';
import { motion } from 'framer-motion';

const PersonalWelcomeSection = () => {
  const { user, isLoading } = useAuthState();
  const [greeting, setGreeting] = useState('');

  useEffect(() => {
    const hour = new Date().getHours();
    if (hour < 12) setGreeting('Good morning');
    else if (hour < 18) setGreeting('Good afternoon');
    else setGreeting('Good evening');
  }, []);

  if (isLoading) {
    return (
      <div className="py-12 bg-gradient-to-r from-blue-50 to-indigo-50">
        <div className="container mx-auto px-4">
          <div className="animate-pulse">
            <div className="h-8 bg-gray-200 rounded w-3/4 mb-4"></div>
            <div className="h-4 bg-gray-200 rounded w-1/2"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="py-12 bg-gradient-to-r from-blue-50 to-indigo-50"
    >
      <div className="container mx-auto px-4">
        {user ? (
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
            <div>
              <h1 className="text-3xl md:text-4xl font-bold text-corporate-primary-100 mb-2">
                {greeting}, {user.user_metadata.first_name || 'Trader'}
              </h1>
              <p className="text-gray-600">
                Stay on top of your trading strategies and market movements.
              </p>
            </div>
            <div className="flex gap-3">
              <Link to="/account">
                <Button className="bg-corporate-primary-100 hover:bg-corporate-primary-75">
                  My Account <User className="ml-2 h-4 w-4" />
                </Button>
              </Link>
              <Link to="/marketplace">
                <Button className="bg-corporate-secondary-100 hover:bg-corporate-secondary-75">
                  Explore Strategies <ArrowRight className="ml-2 h-4 w-4" />
                </Button>
              </Link>
            </div>
          </div>
        ) : (
          <div className="text-center">
            <h1 className="text-3xl md:text-4xl font-bold text-corporate-primary-100 mb-4">
              Welcome to METRADE
            </h1>
            <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
              Join thousands of traders using professional trading strategies.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <Link to="/signup">
                <Button className="bg-corporate-secondary-100 hover:bg-corporate-secondary-75">
                  Get Started <ArrowRight className="ml-2 h-4 w-4" />
                </Button>
              </Link>
              <Link to="/auth">
                <Button variant="outline">
                  <User className="mr-2 h-4 w-4" /> Sign In
                </Button>
              </Link>
            </div>
          </div>
        )}
      </div>
    </motion.div>
  );
};

export default PersonalWelcomeSection;
